/* FamilyFit — acord pentru livrarea imediată a conținutului digital
   OUG nr. 34/2014, art. 16 lit. m).

   Caseta se montează în AMBELE locuri (sertar de coș și pagina /cart),
   înaintea oricărui .cart__ctas. Pagina de produs rămâne neatinsă.

   Acordul se scrie în cart.attributes, deci ajunge în comandă.

   AMPRENTA COȘULUI: acordul e valabil doar pentru coșul pentru care a fost
   dat. Salvăm alături lista de variante din coș; dacă se schimbă (se adaugă
   sau se scoate un produs, se golește coșul), acordul se șterge automat și
   caseta revine nebifată. Fără asta, cineva putea bifa pentru o carte, goli
   coșul, adăuga alta și cumpăra cu un acord dat înainte să aleagă produsul.
   Cheia amprentei începe cu "_", convenția Shopify pentru atribute care nu se
   arată clientului. */
(function () {
  'use strict';

  var TEXT = 'Sunt de acord ca livrarea conținutului digital să înceapă imediat după plată și confirm că, prin aceasta, îmi pierd dreptul de retragere în 14 zile.';
  var REFERINTA = 'Conform art. 16 lit. m) din OUG nr. 34/2014.';
  var AVERTISMENT = 'Bifează acordul ca să poți continua.';

  var CHEIE = 'Acord livrare digitală imediată';
  var CHEIE_DATA = 'Acord dat la';
  var CHEIE_AMPRENTA = '_acord_amprenta_cos';
  var VALOARE = 'Da — accept începerea livrării și îmi pierd dreptul de retragere (OUG 34/2014, art. 16 lit. m)';

  var CLASA = 'ff-consent';
  var SEL_BUTON = '#checkout, button[name="checkout"], .cart__checkout-button';
  var SEL_EXPRES = 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart,' +
                   ' .accelerated-checkout-block, .shopify-payment-button, .wallet-cart-button';
  var SEL_ZONE = '.cart__ctas, ' + SEL_EXPRES;
  var SEL_EXCLUS = '.buy-buttons-block';

  var acord = false;
  var pornit = false;
  var inCurs = false;
  var ultimaCitire = 0;

  function nimic() {}

  function eDinProdus(el) {
    return !!(el && el.closest && el.closest(SEL_EXCLUS));
  }

  function amprenta(c) {
    if (!c || !c.items || !c.items.length) return '';
    var id = [], i;
    for (i = 0; i < c.items.length; i++) id.push(c.items[i].variant_id);
    id.sort(function (a, b) { return a - b; });
    return id.join('-');
  }

  function stiluri() {
    if (document.getElementById('ff-consent-styles')) return;
    var s = document.createElement('style');
    s.id = 'ff-consent-styles';
    s.textContent =
      '.ff-consent{display:flex;gap:.6rem;align-items:flex-start;width:100%;margin:.75rem 0;' +
      'padding:.75rem .8rem;border:1px solid rgb(var(--color-foreground-rgb,0 0 0)/.25);' +
      'border-radius:8px;font-size:.78rem;line-height:1.45;text-align:left;box-sizing:border-box}' +
      '.ff-consent input{margin:.15rem 0 0;width:1.05rem;height:1.05rem;flex:0 0 auto;cursor:pointer}' +
      '.ff-consent label{cursor:pointer;display:block}' +
      '.ff-consent__legal{display:block;margin-top:.25rem;font-size:.86em;opacity:.62}' +
      '.ff-consent[data-lipsa="true"]{border-color:#c0392b;background:rgba(192,57,43,.07)}' +
      '.ff-consent__avertisment{display:none;color:#c0392b;font-weight:600;margin-top:.35rem}' +
      '.ff-consent[data-lipsa="true"] .ff-consent__avertisment{display:block}' +
      '.ff-blocat{position:relative}' +
      '.ff-blocat > *:not(.ff-scut){opacity:.4;pointer-events:none !important}' +
      '.ff-scut{position:absolute;inset:0;z-index:20;cursor:not-allowed;background:transparent;' +
      'pointer-events:auto !important;opacity:1 !important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function creeaza(loc) {
    var w = document.createElement('div');
    w.className = CLASA;
    w.setAttribute('data-ff-loc', loc);
    var id = 'ff-consent-' + loc;
    var inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.id = id;
    inp.checked = acord;
    var box = document.createElement('div');
    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.appendChild(document.createTextNode(TEXT));
    var leg = document.createElement('span');
    leg.className = 'ff-consent__legal';
    leg.textContent = REFERINTA;
    lab.appendChild(leg);
    var av = document.createElement('div');
    av.className = 'ff-consent__avertisment';
    av.textContent = AVERTISMENT;
    box.appendChild(lab);
    box.appendChild(av);
    w.appendChild(inp);
    w.appendChild(box);
    inp.addEventListener('change', function () {
      acord = inp.checked;
      sincronizeaza();
      aplica();
      scrie(acord);
    });
    return w;
  }

  function cosJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function citeste() {
    if (inCurs) return Promise.resolve();
    inCurs = true;
    ultimaCitire = Date.now();
    return cosJson().then(function (c) {
      var a = (c && c.attributes) || {};
      var avea = !!a[CHEIE];
      var acum = amprenta(c);
      if (avea && a[CHEIE_AMPRENTA] !== acum) {
        /* coșul s-a schimbat de când a fost dat acordul — nu mai e valabil */
        acord = false;
        sincronizeaza();
        aplica();
        inCurs = false;
        return scrie(false, true);
      }
      acord = avea;
      sincronizeaza();
      aplica();
      inCurs = false;
    }).catch(function () { inCurs = false; });
  }

  function scrie(bifat, taciut) {
    return cosJson().then(function (c) {
      var a = {};
      a[CHEIE] = bifat ? VALOARE : '';
      a[CHEIE_DATA] = bifat ? new Date().toISOString() : '';
      a[CHEIE_AMPRENTA] = bifat ? amprenta(c) : '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: a })
      });
    }).catch(function (err) {
      if (window.console && !taciut) console.error('[ff-consent] nu am putut scrie acordul', err);
    });
  }

  function sincronizeaza() {
    var list = document.querySelectorAll('.' + CLASA), i;
    for (i = 0; i < list.length; i++) {
      var cb = list[i].querySelector('input');
      if (cb && cb.checked !== acord) cb.checked = acord;
      if (acord) list[i].removeAttribute('data-lipsa');
    }
  }

  function refuza(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var list = document.querySelectorAll('.' + CLASA), i, vizibil = null;
    for (i = 0; i < list.length; i++) list[i].setAttribute('data-lipsa', 'true');
    for (i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length) { vizibil = list[i]; break; }
    }
    if (vizibil && vizibil.scrollIntoView) {
      vizibil.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return false;
  }

  function aplica() {
    var i, list;
    list = document.querySelectorAll(SEL_BUTON);
    for (i = 0; i < list.length; i++) {
      if (eDinProdus(list[i])) continue;
      list[i].disabled = !acord;
      list[i].setAttribute('aria-disabled', String(!acord));
    }
    list = document.querySelectorAll(SEL_ZONE);
    for (i = 0; i < list.length; i++) {
      var el = list[i];
      if (eDinProdus(el)) continue;
      var scut = el.querySelector(':scope > .ff-scut');
      if (acord) {
        el.classList.remove('ff-blocat');
        if (scut) scut.parentNode.removeChild(scut);
      } else {
        el.classList.add('ff-blocat');
        if (!scut) {
          var d = document.createElement('div');
          d.className = 'ff-scut';
          d.setAttribute('title', AVERTISMENT);
          d.addEventListener('click', refuza, true);
          el.appendChild(d);
        }
      }
    }
  }

  function monteaza() {
    try {
      stiluri();
      var vechi = document.querySelectorAll(SEL_EXCLUS + ' .' + CLASA), k;
      for (k = 0; k < vechi.length; k++) {
        if (vechi[k].parentNode) vechi[k].parentNode.removeChild(vechi[k]);
      }
      var zone = document.querySelectorAll('.cart__ctas'), i;
      for (i = 0; i < zone.length; i++) {
        var ctas = zone[i];
        if (eDinProdus(ctas)) continue;
        var p = ctas.parentElement;
        if (!p) continue;
        if (p.querySelector(':scope > .' + CLASA)) continue;
        var loc = p.closest('.cart-drawer__summary') ? 'sertar' : 'pagina';
        p.insertBefore(creeaza(loc), ctas);
      }
      sincronizeaza();
      aplica();
      /* re-verific amprenta după orice schimbare de coș, cu limitare de ritm */
      if (!inCurs && Date.now() - ultimaCitire > 1200) citeste();
    } catch (err) {
      if (window.console) console.error('[ff-consent]', err);
    }
  }

  document.addEventListener('click', function (e) {
    if (acord) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (eDinProdus(t)) return;
    if (t.closest(SEL_BUTON) || t.closest(SEL_ZONE)) refuza(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (acord) return;
    var s = e.submitter;
    if (eDinProdus(s)) return;
    if (s && (s.name === 'checkout' || (s.closest && s.closest(SEL_BUTON)))) refuza(e);
  }, true);

  var timer = null;
  var obs = new MutationObserver(function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(monteaza, 60);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  function porneste() {
    if (pornit) return;
    pornit = true;
    monteaza();
    citeste();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }
})();
